import {Component, NgZone, OnInit} from "@angular/core";
import {EventService} from "../../core/services/event.service";

@Component({
    selector: 'countdown-timer',
    templateUrl: './countdown-timer.component.html',
    styleUrls: ['./countdown-timer.component.scss']
})
export class CountdownTimerComponent implements OnInit {

    private participant: any;
    private kickoffDate: any;
    private kickoffDateStr: string;
    private title: string;
    private subtitle: string;
    private active: boolean;
    private flipWeek: string;
    private flipDay: string;
    private flipHour: string;
    private flipMin: string;
    private flipSec: string;
    private week: any;
    private day: any;
    private hour: any;
    private min: any;
    private sec: any;

    constructor(
        public eventService: EventService,
        private ngZone: NgZone
    ) {
        // Anytime we switch to an event that requires a countdown, update the kickoffDate and display text.
        // However, if the clock is already ticking we don't want to initiate a second, redundant loop.
        this.eventService.onEventChange.subscribe(event => {
            this.participant = event.gql.Participant[0];
            var isActive = this.eventService.displayCountdownTimerForSelectedEvent();
            if (isActive) {
                this.kickoffDate = new Date(this.participant.fundraiser.kickoffDate);
                this.kickoffDateStr = this.participant.fundraiser.kickoffDateStr;
                this.formatDateText();
            }
            if (this.active != isActive) { // Only begin the ticking loop if the clock is not already ticking
                this.active = isActive;
                if (this.active) {
                    this.incrementClock();
                }
            }
        });
    }

    // On the initial load, check if a countdown should begin.
    // If so, set the kickoff date and display text; begin ticking loop
    ngOnInit() {
        this.participant = this.eventService.selectedEvent.gql.Participant[0];
        this.active = this.eventService.displayCountdownTimerForSelectedEvent();
        if (this.active) {
            this.kickoffDate = new Date(this.participant.fundraiser.kickoffDate);
            this.kickoffDateStr = this.participant.fundraiser.kickoffDateStr;
            this.formatDateText();
            this.incrementClock();
        }
    }

    formatDateText() {
        var dateParts = this.kickoffDateStr.split(/\s+/); // SQL pads single-digit days with an extra space
        // i.e. Oct 24 2019
        this.title = dateParts[0] + ' ' + dateParts[1] + ' ' + dateParts[2];
        // i.e. 12:00AM EST
        this.subtitle = dateParts[3] + ' ' + dateParts[4];
    }

    incrementClock() {
        // Find the difference between now and the countdown date
        var countdownDate = this.kickoffDate.getTime();
        var now = new Date().getTime();
        var diff = countdownDate - now;

        // Time calculations for weeks, days, hours, minutes and seconds
        var weeks = Math.floor(diff / (1000 * 60 * 60 * 24 * 7));
        var days = Math.floor((diff % (1000 * 60 * 60 * 24 * 7)) / (1000 * 60 * 60 * 24));
        var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((diff % (1000 * 60)) / 1000);

        this.triggerAnimations(weeks, days, hours, minutes, seconds);

        const self = this;
        
        /**
         * Using NgZone.runOutsideAngular so setTimeout doesn't block Automated Testing 
         * by preventing Testability status from becoming 'Stable'.
         */
        this.ngZone.runOutsideAngular(() => {

            // If there is less than a second left, the clock is at zero; stop ticking
            if (diff < 1000) {
                this.active = false;
                setTimeout(function () {
                    self.ngZone.run(() => {
                        self.eventService.reloadCountdownRelatedData(); 
                    });
                }, 3000)
            }

            // Wait for the animation to finish before updating the clock
            setTimeout(function() {
                weeks = weeks < 0 ? 0 : weeks;
                self.week = weeks < 10 ? '0' + weeks : weeks;
                days = days < 0 ? 0 : days;
                self.day = days < 10 ? '0' + days : days;
                hours = hours < 0 ? 0 : hours;
                self.hour = hours < 10 ? '0' + hours : hours;
                minutes = minutes < 0 ? 0 : minutes;
                self.min = minutes < 10 ? '0' + minutes : minutes;
                seconds = seconds < 0 ? 0 : seconds;
                self.sec = seconds < 10 ? '0' + seconds : seconds;
                self.ngZone.run(() => {
                    self.resetAnimations();
                });
            }, 300);

            // LPS-3523: Only recurse if the timer is still active
            if (this.active) {
                // Wait 1 second and increment again
                setTimeout(function () {
                    self.ngZone.run(() => {
                        self.incrementClock();
                    });
                }, 1000);
            }
        });
    }

    // Trigger the flip animations when needed
    triggerAnimations (weeks, days, hours, minutes, seconds) {
        // The animation is triggered by adding the 'flip' class to the element
        if (this.week != weeks) {
            this.flipWeek = 'flip';
        }
        if (this.day != days) {
            this.flipDay = 'flip';
        }
        if (this.hour != hours) {
            this.flipHour = 'flip';
        }
        if (this.min != minutes) {
            this.flipMin = 'flip';
        }
        this.flipSec = 'flip'
    }

    resetAnimations() {
        this.flipWeek = '';
        this.flipDay = '';
        this.flipHour = '';
        this.flipMin = '';
        this.flipSec = '';
    }
}
